import styled from "styled-components";

export const Player = styled.div`
    height: 100%;
    width: 100%;
`;

export const DeliveryAddress = styled.div<{ show: boolean }>(({ show }) => ({
    width: "100%",
    transition: "opacity 300ms, visibility 300ms",
    visibility: show ? "visible" : "hidden",
    opacity: show ? 1 : 0,
}));

export const Container = styled.div`
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: #fff;
    outline: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
`;

export const TickScreenContentContainer = styled.div({
    position: "absolute",
    top: "55%",
    left: "0",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
});

export const AdditionalDetails = styled.div<{ show: boolean }>(({ show }) => ({
    position: "absolute",
    top: "85%",
    width: "100%",
    transition: "opacity 300ms, visibility 300ms",
    visibility: show ? "visible" : "hidden",
    opacity: show ? 1 : 0,
}));

export const ImageWrapper = styled.div({
    display: "flex",
    justifyContent: "center",
});
